import { ROLES } from "../../common/enums";
import HomeIconMenu from "../../assets/ic20-home.png";
import contestIconMenu from "../../assets/ic20-contests.png";
import podcastIconMenu from "../../assets/ic20-podcast.png";
import newsIconMenu from "../../assets/ic20-news.png";
import contactsIconMenu from "../../assets/ic20-contacts.png";
import ShopButtonBlack from "../../assets/icon/ShopButtonBlack";
import Chat from "../../assets/icon/Chat";

export const desctopMenuLinks: {
  [index: string]: {
    [index: string]: { title: string; path: string; icon?: any };
  };
} = {
  [ROLES.ADMIN]: {
    // podcasts: {
    //   title: "Головна",
    //   path: "/",
    //   icon: HomeIconMenu,
    // },
    news: {
      title: "Новини",
      path: "/news",
    },
    involvement: {
      title: "Конкурси",
      path: "/contests",
    },
    // podcasts: {
    //   title: "Подкасти",
    //   path: "/podcasts",
    //   icon: podcastIconMenu,
    // },
    contacts: {
      title: "Зв'язатися",
      path: "/contacts",
      icon: Chat,
    },
    silpo: {
      title: "silpo.ua",
      path: "https://silpo.ua/",
      icon: ShopButtonBlack,
    },
  },
};
